import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import { formatDate } from '../../utils/date';

const SalesHorseLink = ({
    children,
    venueUid,
    saleDate,
    lotNo,
    lotLetter,
}) => {
    if (!venueUid || !saleDate || !lotNo) {
        return null;
    }

    const date = formatDate(saleDate, 'Y-MM-DD');
    const url =
        `/bloodstock/sales/catalogues/${venueUid}/${date}?lot=${lotNo}&letter=${lotLetter || ' '}`;

    return (
        <a
            className="ui-link ui-link_table js-popupLink js-navigate-url"
            href={url}
        >
            {children || formatDate(saleDate, 'DDMMMYY')}
            <Svg
                iconName="right"
                className="ui-icon ui-icon__btn chevronIcon"
                size="XSmall"
            />
        </a>
    );
};

SalesHorseLink.propTypes = {
    children: PropTypes.node,
    venueUid: PropTypes.number,
    saleDate: PropTypes.string,
    lotNo: PropTypes.number,
    lotLetter: PropTypes.string,
};

export default SalesHorseLink;



// WEBPACK FOOTER //
// ./src/js/shared/links/SalesHorseLink.jsx